import { render } from "./heatmap.vue?vue&type=template&id=095038c4"
import script from "./heatmap.vue?vue&type=script&lang=js"
export * from "./heatmap.vue?vue&type=script&lang=js"

import "./heatmap.vue?vue&type=style&index=0&id=095038c4&lang=css"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__